<template>
  <div class="page shop-page shop-entry-page">
    <div class="columns">
      <div class="column">
        <div class="breadcrumb">
          <router-link to="/">KK</router-link> <i class="icon icon-chevron-right"></i> <router-link to="/">Beliebt</router-link>
        </div>
        
        <h1>Unsere beliebtesten Artikel</h1>
      </div>
    </div>
    
   <div class="columns flex valign-top wrap quarter">
      <div class="column" v-for="(product, i) in productHighlights" :key="i">
         <router-link class="product-preview-link" :to="{ name: 'DetailPage', params: { pg: product.pg, artnr: product.artnr } }">
              <div class="prod-img-container">
                <img v-if="product.bild != '' && ImageExist( '/upload/product-images/' + product.bild ) " :src=" '/upload/product-images/' + product.bild ">
                <img class="placholder" v-else :src=" product.bio == 'J' ? '/upload/product-images/platzhalter_bio_bw.png':'/upload/product-images/platzhalter_artikelohnefoto.png' ">
              </div>
              
              <span class="link-label-product-preview">{{product.bez1}}</span>
          </router-link>
      </div>
    </div>
    
 </div>
</template>
<script>
import topProducts    from '../data/top-products.json';  
import products       from '../data/etar2.json';
import categories     from '../data/categories.json';

export default {
    name: 'HomePage',
    data: function(){
      return {
        productHighlights: []
      }
    },
  
    computed: {
        user () {
            return this.$store.state.authentication.user;
        },
        users () {
            //return this.$store.state.users.all;
        }
    },
    created (){
      
      topProducts.forEach( (topitem)=>{
           var topproduct = products.filter((item) => { return item.artnr == topitem.artnr });
          if( topproduct.length > 0) {
            //console.log(topproduct[0] )
            this.productHighlights.push( topproduct[0] );
          }
      })
    },
    methods: {
      ImageExist(url) {
           var img = new Image();
           img.src = url;
           //console.log(img.width);
           return true //img.width > 0;
        },
    }    
};
</script>
<style>
  .shop-entry-page h1 { text-align: left; }
  
  .shop-entry-page .prod-img-container { overflow: hidden; }

  .shop-entry-page .p-bio img { display: inline-block; max-width: 6em; }
  .shop-entry-page .product-preview-link { color: #00853e; text-decoration: none; }
  .shop-entry-page .product-preview-link span { display: block; padding: 0.222222em 0; }
  .shop-entry-page .product-preview-link img { transform: scale(1); transition: transform 0.2s; }
  .shop-entry-page .product-preview-link:hover img { transform: scale(1.03); }
  .shop-entry-page .placholder { opacity: 0.3; }
  
</style>